import * as React from 'react';

import classnames from 'classnames';

import type {SalesDocumentType} from '../../lead-sidebar/sales-documents/types';
import {RichTextDisplay} from '../../rich-text-display/rich-text-display';
import {Body} from '../../typography/body';

import styles from '../quote.module.css';

type Props = {
    type: SalesDocumentType;
    leftHeaderText: string;
    rightHeaderText: string;
    logo: string | null;
};

export function QuoteHeader(props: Props) {
    return (
        <div className='full-height full-width flex justify-sb pad-16'>
            {props.logo && (
                <div className={styles['logo-container']}>
                    <img src={props.logo} alt='logo' />
                </div>
            )}
            <div className={classnames(styles['text-container'], styles['normal-font'])}>
                <RichTextDisplay html={props.leftHeaderText} />
            </div>
            <div className={classnames(styles['text-container'], styles['normal-font'])}>
                <RichTextDisplay html={props.rightHeaderText} />
            </div>
            <Body isBold={true} size='xlarge' color='dark'>
                {props.type === 'Quote' ? 'QUOTE' : 'INVOICE'}
            </Body>
        </div>
    );
}
